(() => {
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const preview = config.designMode || window.Shopify?.designMode || ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
  if (preview) return;
  const i18n = window.MayLondonI18n;
  const path = i18n.unlocalize(location.pathname).replace(/\/$/, '');
  const destination = path === '/pages/web-development';
  const missing = document.body.classList.contains('template-404');
  const marker = 'mayLondonInspectorHint';
  let timer, toastTimer, toast, count = 0, last = 0, redirected = false;
  const home = () => {
    if (redirected) return;
    redirected = true; clearTimeout(timer);
    location.replace(i18n.route(''));
  };
  const notify = key => {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'inspector-toast';
      toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      document.body.append(toast);
    }
    toast.textContent = i18n.t(key); toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 4500);
  };
  if (destination) {
    try {
      const until = Number(sessionStorage.getItem(marker)); sessionStorage.removeItem(marker);
      if (until > Date.now() && until < Date.now() + 60000) notify('guard_hint');
    } catch (_) {}
    return;
  }
  if (missing) timer = setTimeout(home, 3000);
  let sizeTimer;
  const cancelTimer = () => { clearTimeout(timer); clearTimeout(toastTimer); clearInterval(sizeTimer); };
  addEventListener('pagehide', cancelTimer);
  addEventListener('pageshow', event => {
    if (!event.persisted) return;
    redirected = false; count = 0;
    document.documentElement.classList.remove('ml-guard-white');
    if (missing) timer = setTimeout(home, 3000);
    else startSizeCheck();
  });
  // Geometry is only a heuristic: side panels can resemble docked developer tools.
  function startSizeCheck() {
    clearInterval(sizeTimer);
    if (missing || !config.inspectorSizeCheck || config.contentProtection === false || /\/(checkout|checkouts)(\/|$)/.test(path)) return;
    const key = 'mayLondonInspectorGeometry';
    const measure = () => ({ sw: screen.width, sh: screen.height, aw: screen.availWidth, ah: screen.availHeight, ow: outerWidth, oh: outerHeight, iw: innerWidth, ih: innerHeight, ratio: devicePixelRatio });
    let baseline = measure(), armed = true, matches = 0, firstProbe = true;
    const near = (a, b, tolerance = 4) => Math.abs(a - b) <= tolerance;
    const sameWindow = (a, b) => ['sw', 'sh', 'ow', 'oh'].every(field => near(a[field], b[field])) && near(a.ratio, b.ratio, 0.01);
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (saved?.baseline && Object.values(saved.baseline).every(Number.isFinite) && sameWindow(baseline, saved.baseline)) {
        baseline = saved.baseline; armed = saved.armed !== false;
      }
    } catch (_) {}
    const save = () => { try { sessionStorage.setItem(key, JSON.stringify({ baseline, armed })); } catch (_) {} };
    save();
    sizeTimer = setInterval(() => {
      if (redirected || document.hidden || count >= 6 || (count > 0 && Date.now() - last < 60000)) return;
      const current = measure();
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      const touch = !matchMedia('(pointer: fine)').matches || current.sw < 1024 || navigator.maxTouchPoints > 0;
      const zoom = Math.abs((window.visualViewport?.scale || 1) - 1) > 0.02;
      if (touch || editing || zoom || document.fullscreenElement || !sameWindow(current, baseline)) {
        baseline = current; matches = 0; firstProbe = false; save(); return;
      }
      const smaller = baseline.iw - current.iw >= 220 || baseline.ih - current.ih >= 220;
      const maximized = near(current.ow, current.aw, 48) && near(current.oh, current.ah, 80);
      const initiallyDocked = firstProbe && maximized && (current.ow - current.iw >= 320 || current.oh - current.ih >= 400);
      if (!smaller && !initiallyDocked) { matches = 0; armed = true; firstProbe = false; baseline = current; save(); return; }
      if (!armed || ++matches < 2) return;
      armed = false; save(); redirected = true; cancelTimer();
      location.replace(i18n.route('404'));
    }, 100);
  }
  startSizeCheck();
  document.addEventListener('keydown', event => {
    const inspect = event.key === 'F12' || (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'i');
    if (!inspect || !event.isTrusted || event.repeat || event.isComposing) return;
    if (missing) { event.preventDefault(); home(); return; }
    if (config.contentProtection === false || /\/(checkout|checkouts)(\/|$)/.test(path)) return;
    event.preventDefault();
    if (count < 6 && Date.now() - last > 60000) count = 0;
    count++; last = Date.now();
    if (count <= 5) {
      notify('guard_' + ['one', 'two', 'three', 'four', 'five'][count - 1]);
    } else if (count === 6) {
      cancelTimer();
      if (window.opener) window.close();
      document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      document.documentElement.classList.add('ml-guard-white');
    } else if (!redirected) {
      redirected = true;
      try { sessionStorage.setItem(marker, String(Date.now() + 30000)); } catch (_) {}
      location.assign(i18n.route('pages/web-development'));
    }
  }, { capture: true });
})();
